import { useEffect } from "react";
import { LuCircleCheck } from "react-icons/lu";
import { LOCAL_STORAGE_KEYS } from "../../config/local_storage_keys";
import { trackEvent } from "../../utils/analyticsUtils";
import BlueWaveLayout from "../common_components/BlueWaveLayout";

export default function SubscriptionsSuccessPage() {
  const handleGoBackToApp = () => {
    const returnUrl = localStorage.getItem(
      LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL
    );
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL);

    window.location.replace(returnUrl || "/");
  };

  useEffect(() => {
    trackEvent("purchase");
  }, []);

  return (
    <BlueWaveLayout>
      <div
        className="flex flex-col items-center justify-center gap-4
      bg-[#F2F3FD] dark:bg-[#1E2023]
      p-10 rounded-lg shadow-xl"
      >
        <LuCircleCheck size={56} className="text-green-500" />
        <p className="text-lg text-center">
          Your payment has been processed successfully
        </p>
        <button
          onClick={handleGoBackToApp}
          className="bg-primary-blue text-white
        py-2 px-4 rounded-lg mt-5
        hover:brightness-150 transition-all duration-300"
        >
          Go back to app
        </button>
      </div>
    </BlueWaveLayout>
  );
}
